import apolloClient from '@/plugins/apollo';
import { $t } from '@/plugins/fluent';
import { DocumentNode } from 'graphql';
import { z } from 'zod';

export const EMPTY_VALUE_STRING = '-';

export function valueToString(value: string | null | undefined) {
    if (value === undefined || value === null || value === '') return EMPTY_VALUE_STRING;
    return value;
}

export function uniqueNameShortField(document: DocumentNode, id?: string) {
    return z
        .string()
        .min(1, $t('input-required'))
        .trim()
        .refine(
            async (value) => {
                if (value) {
                    const result = await apolloClient.query({
                        query: document,
                        variables: { name: value },
                    });
                    const existingObjectId = result.data?.existingObject?.id;
                    if (existingObjectId) {
                        if (id) {
                            return existingObjectId === id;
                        }
                        return false;
                    }
                }
                return true;
            },
            { message: $t('nameshort-already-taken') },
        );
}

export function uniqueEmailField(document: DocumentNode, email?: string) {
    return z
        .string()
        .email($t('email-invalid'))
        .min(1, $t('input-required'))
        .trim()
        .toLowerCase()
        .refine(
            async (value) => {
                if (value) {
                    const result = await apolloClient.query({
                        query: document,
                        variables: { email: value },
                    });
                    const existingObjectEmail = result.data?.existingObject?.email;
                    if (existingObjectEmail) {
                        if (email) {
                            return existingObjectEmail === email;
                        }
                        return false;
                    }
                    return true;
                }
                return true;
            },
            { message: $t('error-email-already-exists') },
        );
}
